import PropTypes from 'prop-types';
import React from 'react';
import { m } from 'framer-motion';
// @mui
import { Dialog, Box, Paper } from '@mui/material';
//
import { varFade } from './variants';

// ----------------------------------------------------------------------

const AnimatedPaper = React.forwardRef(
  (
    { animationVariants, animationSx, children, onBackdropClick, ...other },
    ref
  ) => (
    <Box
      component={m.div}
      {...(animationVariants ||
        varFade({
          distance: 120,
          durationIn: 0.32,
          durationOut: 0.24,
          easeIn: 'easeInOut'
        }).inUp)}
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        onClick={onBackdropClick}
        sx={{ width: '100%', height: '100%', position: 'fixed' }}
      />
      <Paper ref={ref} sx={animationSx} {...other}>
        {children}
      </Paper>
    </Box>
  )
);

AnimatedPaper.propTypes = {
  animationSx: PropTypes.object,
  animationVariants: PropTypes.object,
  children: PropTypes.node,
  onBackdropClick: PropTypes.func
};

AnimatedPaper.displayName = 'AnimatedDialogPaper';

// ----------------------------------------------------------------------

DialogAnimate.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  sx: PropTypes.object,
  variants: PropTypes.object
};

export default function DialogAnimate({
  open = false,
  variants,
  onClose,
  children,
  sx,
  ...other
}) {
  const { PaperProps, ...dialogProps } = other;

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperComponent={AnimatedPaper}
      PaperProps={{
        ...PaperProps,
        animationVariants: variants,
        animationSx: sx,
        onBackdropClick: onClose
      }}
      {...dialogProps}
    >
      {children}
    </Dialog>
  );
}
